module.exports = __webpack_public_path__ + "img/video_thumb_01.8fa719e2.png";